import { render, staticRenderFns } from "./page5.vue?vue&type=template&id=a4c6b8fc&"
import script from "./page5.vue?vue&type=script&lang=js&"
export * from "./page5.vue?vue&type=script&lang=js&"
import style0 from "./page5.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports